import React from 'react';
import { reduxForm } from 'redux-form';
import { Box } from '@mui/material';
import { get } from 'lodash';

import Loader from '../../../../../../common/components/Loader/Loader';
import { Tab, Tabs } from '../../../../../../common/components/Tabs/Tabs';
import Select from '../../../../../../common/components/Select/Select';
import { MenuItem } from '../../../../../../common/components/MenuItem/MenuItem';
import { isMobile } from '../../../../../../common/services/isMobile';
import CommonNavigationPrompt from '../../../../../../common/components/NavigationPrompt/component';

import EdgeControllerDetailsToolbar from '../EdgeControllerDetailsToolbar/EdgeControllerDetailsToolbar';
import EdgeControllerInfoTab from '../../../edgeControllerInfoTab/ui/EdgeControllerInfoTab';
import Tasks from '../../../tasks/ui/Tasks';
import EdgeControllerComponentsTab from '../../../edgeControllerComponentsTab/ui/EdgeControllerComponentsTab';
import EdgeControllerConfigurationTab from '../../../edgeControllerConfigurationTab/ui/EdgeControllerConfigurationTab';
import EdgeControllerPlazaTab from '../../../edgeControllerPlazaTab/ui/EdgeControllerPlazaTab';
import EdgeControllerMonitoringTab from '../../../edgeControllerMonitoringTab/ui/EdgeControllerMonitoringTab';

export const FORM_NAME = 'edgeControllerDetailsForm';

const EDGE_CONTROLLER_TABS = [
  { label: 'Details', value: 'details' },
  { label: 'Tasks', value: 'tasks' },
  { label: 'Components', value: 'components' },
  { label: 'Configuration', value: 'configuration' },
  { label: 'Plaza', value: 'plaza' },
  { label: 'Monitoring', value: 'monitoring' },
];

function EdgeControllerDetailsForm({
  handleSubmit,
  currentEdgeControllerData = null,
  activeTabValue,
  selectTab,
  isFetching = false,
  readOnly = true,
  dirty = false,
  ...restProps
}) {
  const props = {
    handleSubmit,
    currentEdgeControllerData,
    activeTabValue,
    selectTab,
    isFetching,
    readOnly,
    dirty,
    ...restProps,
  };

  const edgeControllerId = get(currentEdgeControllerData, 'edgeControllerId');

  const onTabChange = (event, tab) => {
    selectTab(tab);
  };

  const mobileTabChange = (event) => {
    selectTab(event.target.value);
  };

  const tabsHeader = !isMobile && (
    <Box className="edge-controller-details-tabs" display="flex" justifyContent="center" width="100%" bgcolor="rgba(39, 94, 99, 0.1)">
      <Tabs variant="scrollable" centered={false} value={activeTabValue} onChange={onTabChange}>
        {EDGE_CONTROLLER_TABS.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
    </Box>
  );

  const tabPanelContent = isFetching ? (
    <Loader />
  ) : (
    <>
      {activeTabValue === 'details' && <EdgeControllerInfoTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'tasks' && edgeControllerId && <Tasks edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'components' && <EdgeControllerComponentsTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'configuration' && <EdgeControllerConfigurationTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'plaza' && <EdgeControllerPlazaTab edgeControllerId={edgeControllerId} {...props} />}
      {activeTabValue === 'monitoring' && <EdgeControllerMonitoringTab edgeControllerId={edgeControllerId} {...props} />}
    </>
  );

  const mobileTabMenu = isMobile && (
    <Select
      className="edge-controller-details-tabs tab-select select-big-icon"
      style={{ width: 260 }}
      value={activeTabValue}
      onChange={mobileTabChange}
    >
      {EDGE_CONTROLLER_TABS.map((tab) => (
        <MenuItem key={tab.value} value={tab.value}>
          {tab.label}
        </MenuItem>
      ))}
    </Select>
  );

  return (
    <>
      <EdgeControllerDetailsToolbar {...props} />

      <form id="edgeControllerDetailsForm" noValidate onSubmit={handleSubmit}>
        <CommonNavigationPrompt when={!readOnly && dirty} />

        {isMobile && mobileTabMenu}

        {tabsHeader}

        <div className="edge-controller-details-form">{tabPanelContent}</div>
      </form>
    </>
  );
}

const EdgeControllerDetailsFormWithReduxForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
})(EdgeControllerDetailsForm);

export default EdgeControllerDetailsFormWithReduxForm;
